import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { shop, girl, text } from './Shop.module.css';
import { imgUrlGenerate } from '../../../helpers';
import { COFFEE, FOR_YOUR_PLEASURE } from '../../../utils/constants';
import Items from '../../../components/Items';
import ItemsSearch from '../../../components/ItemsSearch';
import ItemsFilter from '../../../components/ItemsFilter';
import { title } from './Shop.module.css';
import Image from '../../../components/UI/Image';
import { string, object, arrayOf, func } from 'prop-types';

const Shop = ({ pageType, items, onItemSelected, onSearch, onFilterSelect }) => (
  <section className={shop}>
    <Container>
      <Row>
        <Col lg={{ size: 4, offset: 2 }}>
          <Image className={girl} src={
            pageType === FOR_YOUR_PLEASURE ? imgUrlGenerate(`coffee_cup.jpg`) :
              pageType === COFFEE ? imgUrlGenerate(`coffee_girl.jpg`) : imgUrlGenerate(`coffee_cup.jpg`)
          } alt="girl"
          />
        </Col>
        <Col lg={{ size: 4 }}>
          <div className={`${title} title`}>About our beans</div>
          <Image className="beans-logo" src={imgUrlGenerate(`Beans_logo_dark.svg`)} alt="Beans logo" />
          <div className={text}>
            Extremity sweetness difficult behaviour he of. On disposal of as landlord horrible.
                                    <br /><br />
            Afraid at highly months do things on at. Situation recommend objection do intention<br />
            so questions. <br />
            As greatly removed calling pleased improve an. Last ask him cold feel<br />
            met spot shy want. Children me laughing we prospect answered followed. At it went<br />
            is song that held help face.
            </div>
        </Col>
      </Row>

      <div className="line" />

      {pageType === COFFEE &&
        (<Row>
          <Col lg={{ size: 4, offset: 2 }}>
            <ItemsSearch onSearch={onSearch} />
          </Col>
          <Col lg={{ size: 5 }}>
            <ItemsFilter onFilterSelect={onFilterSelect} />
          </Col>
        </Row>)
      }

      <Row>
        <Col lg={{ size: 10, offset: 1 }}>
          <Items items={items} pageType={pageType} onItemSelected={onItemSelected} />
        </Col>
      </Row>
    </Container>
  </section>
)

Shop.propTypes = {
  pageType: string,
  items: arrayOf(object),
  onItemSelected: func,
  onSearch: func,
  onFilterSelect: func,
}

Shop.defaultProps = {
  pageType: '',
  items: [{}],
  onItemSelected: () => { },
  onSearch: () => { },
  onFilterSelect: () => { },
}

export default Shop